import React, { useEffect } from 'react';
import ThemeProvider from '@mui/material/styles/ThemeProvider';
import {
  BrowserRouter,
  Navigate,
  Outlet,
  Route,
  Routes, useLocation,
} from "react-router-dom";
import './App.css';
import theme from './theme';
import Login from './components/login/Login';
import Toolbar from './components/toolbar/Toolbar';
import { authUser, disposeViaExternalApps, getCrmInfo, getdispositionListForExternalApps, setTransferCall } from './services/agent.service';
import { useSnackbar } from 'notistack';
import { setCloseSnackBarRef, setSnackBarRef, showErrorNotification, showSuccessNotification, showWarningNotification } from './components/common/NotiService';
import { aToolbar } from './toolbar';
import { changeAgentMode, manualDial, pauseAgent, releaseAgent } from './services/webEventHandlers';
import { handleAgentLogin } from './services/authService';
import CookieService from './services/cookie.service';
import { AGENT_STATE } from './constants';
import LocalStorageService from './services/localstorage.service';
import { store } from './context/store';
import { setLoginViaAppData, setShowingToolbarInCrm, setToolbarTabActive, setSendSmsAutoSend } from './context/toolbarSlice';
import { getHeaderImages, getPauseReasons } from './services/util';
import { app } from './config';
import dayjs from "dayjs";
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import 'dayjs/locale/en';
import moment from "moment-timezone";
import WSocketService from './services/websocket.service';
import { setCallDetails } from "./context/callSlice";
import { handleActiveSessionId, handleChatAcceptStatus, pauseAfterSession } from './context/digitalSlice';
import SsoLogin from './components/login/SsoLogin';
import { addNewTab } from "./context/dashboardSlice";

dayjs.extend(utc);
dayjs.extend(timezone);

function App() {
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  useEffect(() => {
    setSnackBarRef(enqueueSnackbar);
    setCloseSnackBarRef(closeSnackbar);
  }, [enqueueSnackbar, closeSnackbar, aToolbar])

  useEffect(() => {
    function getParameterByName(name) {
      const url = new URL(window.location.href);
      const searchParams = new URLSearchParams(url.search);
      // Note: The get() method returns null if the parameter is not found
      const paramValue = searchParams.get(name);
      // Decode the parameter value and replace '+' with a space
      return paramValue ? decodeURIComponent(paramValue.replace(/\+/g, " ")) : null;
    }

    let sfdcOrigin = getParameterByName("sfdcIframeOrigin");
    let sfdcClassicOrigin = getParameterByName("sfdcIFrameOrigin");
    let sfdcMode = getParameterByName("mode");
    var zendeskOrigin = getParameterByName("origin");
    var crm = getParameterByName("crm");

    if ((sfdcOrigin !== null && sfdcOrigin !== "") && (sfdcMode !== null && sfdcMode !== "" && sfdcMode === "Lightning")) {
      // include sfdc lightining files
      store.dispatch(setShowingToolbarInCrm(true));
      let scriptopencti = document.createElement("script");
      scriptopencti.src = app.urls["crm_cdn"] + "salesforce/opencti_min_56.js";
      scriptopencti.onload = function () {
        console.log("Salesforce lightning SDK is installed");
      }
      document.head.appendChild(scriptopencti);
      let scriptsalesforcecommoninlighting = document.createElement("script");
      scriptsalesforcecommoninlighting.src = app.urls["crm_cdn"] + "salesforce/salesforce_common.js";
      scriptsalesforcecommoninlighting.onload = function () {
        console.log("CA common salesforce integration is installed");
        let scriptlightning = document.createElement("script");
        scriptlightning.src = app.urls["crm_cdn"] + "salesforce/salesforce_light.js";
        scriptlightning.onload = function () {
          console.log("CA lightning salesforce integration is installed");
          aToolbar !== undefined && aToolbar.trigger("init");
        }
        document.head.appendChild(scriptlightning);
      }
      document.head.appendChild(scriptsalesforcecommoninlighting);
    } else if (sfdcClassicOrigin !== null && sfdcClassicOrigin !== "") {
      // include sfdc classic files
      store.dispatch(setShowingToolbarInCrm(true))
      let scriptinteraction = document.createElement("script");
      scriptinteraction.src = app.urls["crm_cdn"] + "salesforce/interaction_56.js";
      scriptinteraction.onload = function () {
        console.log("Salesforce classic SDK is installed");
      }
      document.head.appendChild(scriptinteraction);
      let scriptsalesforcecommoninclassic = document.createElement("script");
      scriptsalesforcecommoninclassic.src = app.urls["crm_cdn"] + "salesforce/salesforce_common.js";
      scriptsalesforcecommoninclassic.onload = function () {
        console.log("CA common salesforce integration is installed");
        let scriptclassic = document.createElement("script");
        scriptclassic.src = app.urls["crm_cdn"] + "salesforce/salesforce_classic.js";
        scriptclassic.onload = function () {
          console.log("CA classic salesforce integration is installed");
          aToolbar !== undefined && aToolbar.trigger("init");
        }
        document.head.appendChild(scriptclassic);
      }
      document.head.appendChild(scriptsalesforcecommoninclassic);
    } else if (crm !== null && crm === "msd365") {
      const iframes = document.querySelectorAll('iframe');
      iframes.forEach(iframe => {
        iframe.sandbox += ' allow-modals';
      });
      if (zendeskOrigin !== null && zendeskOrigin !== "") {
        store.dispatch(setShowingToolbarInCrm(true))
        let scriptMSDynCILibrary = document.createElement("script");
        scriptMSDynCILibrary.src = `https://${zendeskOrigin}/webresources/Widget/msdyn_ciLibrary.js`;
        scriptMSDynCILibrary.setAttribute("data-crmurl", `https://${zendeskOrigin}`);
        scriptMSDynCILibrary.setAttribute("data-cifid", 'CIFMainLibrary');
        scriptMSDynCILibrary.onload = function () {
          console.log("Microsoft Dynamics 365 integration is installed");
          aToolbar?.trigger("init");
        };
        let scriptDynamics365 = document.createElement("script");
        scriptDynamics365.src = app.urls["crm_cdn"] + "dynamics365/dynamics365.js";
        scriptDynamics365.onload = function () {
          console.log("CA Dynamics 365 integration is installed");
          document.head.appendChild(scriptMSDynCILibrary);
        };
        document.head.appendChild(scriptDynamics365);
      } else {
        console.error("paramter missing for dynamics 365 integration");
      }
    } else if (crm !== null && crm === "freshservice") {
      store.dispatch(setShowingToolbarInCrm(true));
      let scriptfreshservice = document.createElement("script");
      scriptfreshservice.src = app.urls["crm_cdn"] + "freshservice/freshservice.js";
      scriptfreshservice.onload = function () {
        console.log("CA freshservice integration is installed");
        aToolbar !== undefined && aToolbar.trigger("init");
      };
      document.head.appendChild(scriptfreshservice);

    }
  }, [])

  async function messageListener(event) {
    if (event.data.cmd) {

      if (event.data.cmd === "manualDial") {
        if (event.data.number === undefined || event.data.number === "") {
          showWarningNotification("PhoneNumber is required")
        }
        else {
          if (store.getState().toolbar.isLoggedIn === true) {
            if (store.getState().call.isCallActivityPresent === false) {
              if (store.getState().toolbar.agent.mode === "manual" || (store.getState().toolbar.agent.mode === "blended" && store.getState().toolbar.blendedModeActiveDialer === "Manual")) {
                if (store.getState().toolbar.agent.state === AGENT_STATE.READY) {
                  const phoneNumRegexExpression = /^\+?\d{3,17}$/;
                  let campaign = LocalStorageService.getItem("selectedCampaign")
                  if (campaign === null || campaign === '' || campaign === "null" || campaign === undefined) {
                    showWarningNotification("Choose a campaign")
                  }
                  else {
                    if (phoneNumRegexExpression.test(event.data.number)) {
                      manualDial(store.getState().toolbar.agent.mode, null, event.data.number, campaign, null, null, event.data.uui, true);
                    }
                    else {
                      showWarningNotification("PhoneNumber is Not Valid")
                    }
                  }
                }
                else {
                  showWarningNotification("Please Change Your State To Ready")
                }
              }
              else {
                showWarningNotification("Please Change Your Mode To Manual Or Manual In Blended Mode")
              }
            }
            else {
              showWarningNotification("You Are already in a call Please finish this call and try again")
            }
          }
          else {
            showWarningNotification("You have not logged In to AgentToolbar yet")
          }
        }
      }
      else if (event.data.cmd === "IVRTransfer") {
        if ((event.data.transferValue === undefined || event.data.transferValue === "") && event.data.typeOfTransfer === "IVR") {
          showWarningNotification("Transfer value is required")
        }
        else {
          if (store.getState().toolbar.isLoggedIn === true) {
            setTransferCall({
              tabValueState: event.data.tabValueState,
              typeOfTransfer: event.data.typeOfTransfer,
              transferValue: event.data.transferValue,
              monitorUcid: event.data.monitorUcid,
              triggeredBy3rdParty: true
            })
          }
          else {
            showWarningNotification("You have not logged In to AgentToolbar yet")
          }
        }
      }
      else if (event.data.cmd === "Dispose") {

        function getSecondsDifference(timeString1, timeString2) {
          const date1 = new Date(timeString1);
          const date2 = new Date(timeString2);
          const differenceInMillis = date1 - date2;
          const differenceInSeconds = differenceInMillis / 1000;
          if (differenceInSeconds > 1) {
            return true;
          }
          else {
            return false
          }
        }

        if (store.getState().toolbar.isLoggedIn === true) {
          if (store.getState().call.isCallActivityPresent !== true) {
            showWarningNotification("call not found")
            return false;
          }
          if (store.getState().call.isCallEnded === true) {
            if (event.data.monitorUcid === undefined || event.data.monitorUcid === null || event.data.monitorUcid === "") {
              showWarningNotification("monitorUcid is required")
            }
            else {
              if (event.data.monitorUcid === store.getState().call.callDetails.monitorUcid) {
                if (event.data.disposition === undefined || event.data.disposition === "") {
                  showWarningNotification("dispositon is required")
                }
                else {
                  const allTimezones = moment.tz.names();
                  let filteredTimeZones = [];
                  allTimezones.map((item) => {
                    let time = dayjs().tz(item);
                    if (time.$u === false) {
                      filteredTimeZones.push(item);
                    }
                  })
                  if (event.data.timezone === undefined || event.data.timezone === null || event.data.timezone === "" || filteredTimeZones.includes(event.data.timezone)) {
                    const userTimezone = store.getState().toolbar.loginDetails.agentInfo.user.userTimezone;
                    let timeZone = (event.data.timezone !== undefined && event.data.timezone !== "") ? event.data.timezone : (userTimezone !== null && userTimezone !== undefined) ? userTimezone : (app.toolbarInstance !== 'us') ? "Asia/Calcutta" : userTimezone
                    let reTime = dayjs(event.data.dateandTime).tz(timeZone).$d
                    let locTime = dayjs().tz(timeZone).$d
                    const dispositionList = await getdispositionListForExternalApps()
                    let dispositionPresented = false;
                    if (dispositionList !== null) {
                      dispositionList.map((item) => {
                        if (item === event.data.disposition) {
                          dispositionPresented = true
                        }
                      })
                    }
                    if (dispositionPresented) {
                      if ((event.data.pauseAgentAfterDisposition === undefined || event.data.pauseAgentAfterDisposition === null) || event.data.pauseAgentAfterDisposition !== true) {
                        if (event.data.dateandTime === undefined || event.data.dateandTime === null || event.data.dateandTime === '') {
                          disposeViaExternalApps({
                            dateandTime: (event.data.dateandTime !== undefined && event.data.dateandTime !== "") ? event.data.dateandTime : null,
                            comments: (event.data.comments !== undefined && event.data.comments !== "") ? event.data.comments : null,
                            disposition: event.data.disposition,
                            timezone: (event.data.timezone !== undefined && event.data.timezone !== "") ? event.data.timezone : (userTimezone !== null && userTimezone !== undefined) ? userTimezone : (app.toolbarInstance !== 'us') ? "Asia/Calcutta" : userTimezone,
                            pauseAgentAfterDisposition: (event.data.pauseAgentAfterDisposition !== undefined && event.data.pauseAgentAfterDisposition !== "") ? event.data.pauseAgentAfterDisposition : null,
                            pauseReason: (event.data.pauseReason !== undefined && event.data.pauseReason !== "") ? event.data.pauseReason : null
                          });
                        }
                        else {
                          if (getSecondsDifference(reTime, locTime)) {
                            let formattedTime = dayjs(event.data.dateandTime).tz(timeZone).format('MM/DD/YYYY HH:mm:ss')
                            event.data.dateandTime = formattedTime
                            disposeViaExternalApps({
                              dateandTime: (event.data.dateandTime !== undefined && event.data.dateandTime !== "") ? event.data.dateandTime : null,
                              comments: (event.data.comments !== undefined && event.data.comments !== "") ? event.data.comments : null,
                              disposition: event.data.disposition,
                              timezone: (event.data.timezone !== undefined && event.data.timezone !== "") ? event.data.timezone : (userTimezone !== null && userTimezone !== undefined) ? userTimezone : (app.toolbarInstance !== 'us') ? "Asia/Calcutta" : userTimezone,
                              pauseAgentAfterDisposition: (event.data.pauseAgentAfterDisposition !== undefined && event.data.pauseAgentAfterDisposition !== "") ? event.data.pauseAgentAfterDisposition : null,
                              pauseReason: (event.data.pauseReason !== undefined && event.data.pauseReason !== "") ? event.data.pauseReason : null
                            });
                          }
                          else {
                            showWarningNotification("callback date and time you have given is less than the current date and time of the region")
                          }
                        }
                      }
                      else {
                        if (event.data.pauseReason === undefined || event.data.pauseReason === null) {
                          showWarningNotification("If you want to pause the agent after disposition submission , pauseReason is required")
                        }
                        else {
                          const pauseReasonsList = await getPauseReasons()
                          let pauseReasonPresented = false;
                          let reason = event.data.pauseReason
                          event.data.pauseReason = {
                            reason: reason,
                            timeLimit: null
                          };
                          if (pauseReasonsList !== null) {
                            pauseReasonsList.map((item) => {
                              if (item.reason === event.data.pauseReason.reason) {
                                pauseReasonPresented = true
                                event.data.pauseReason.reason = item.reason
                                event.data.pauseReason.timeLimit = item.timeLimit
                              }
                            })
                          }
                          if (pauseReasonPresented) {
                            if (event.data.dateandTime === undefined || event.data.dateandTime === null || event.data.dateandTime === '') {
                              disposeViaExternalApps({
                                dateandTime: (event.data.dateandTime !== undefined && event.data.dateandTime !== "") ? event.data.dateandTime : null,
                                comments: (event.data.comments !== undefined && event.data.comments !== "") ? event.data.comments : null,
                                disposition: event.data.disposition,
                                timezone: (event.data.timezone !== undefined && event.data.timezone !== "") ? event.data.timezone : (userTimezone !== null && userTimezone !== undefined) ? userTimezone : (app.toolbarInstance !== 'us') ? "Asia/Calcutta" : userTimezone,
                                pauseAgentAfterDisposition: (event.data.pauseAgentAfterDisposition !== undefined && event.data.pauseAgentAfterDisposition !== "") ? event.data.pauseAgentAfterDisposition : null,
                                pauseReason: (event.data.pauseReason !== undefined && event.data.pauseReason !== "") ? event.data.pauseReason : null
                              });
                            }
                            else {
                              if (getSecondsDifference(reTime, locTime)) {
                                let formattedTime = dayjs(event.data.dateandTime).tz(timeZone).format('MM/DD/YYYY HH:mm:ss')
                                console.log(formattedTime)
                                event.data.dateandTime = formattedTime
                                disposeViaExternalApps({
                                  dateandTime: (event.data.dateandTime !== undefined && event.data.dateandTime !== "") ? event.data.dateandTime : null,
                                  comments: (event.data.comments !== undefined && event.data.comments !== "") ? event.data.comments : null,
                                  disposition: event.data.disposition,
                                  timezone: (event.data.timezone !== undefined && event.data.timezone !== "") ? event.data.timezone : (userTimezone !== null && userTimezone !== undefined) ? userTimezone : (app.toolbarInstance !== 'us') ? "Asia/Calcutta" : userTimezone,
                                  pauseAgentAfterDisposition: (event.data.pauseAgentAfterDisposition !== undefined && event.data.pauseAgentAfterDisposition !== "") ? event.data.pauseAgentAfterDisposition : null,
                                  pauseReason: (event.data.pauseReason !== undefined && event.data.pauseReason !== "") ? event.data.pauseReason : null
                                });
                              }
                              else {
                                showWarningNotification("callback date and time you have given is less than the current date and time of the region")
                              }
                            }
                          }
                          else {
                            showWarningNotification("PauseReason you have give is not in the List")
                          }
                        }
                      }
                    }
                    else {
                      showWarningNotification("Disposition you have give is not in the List")
                    }
                  }
                  else {
                    showWarningNotification("timezone you have give is not in the List")
                  }
                }
              }
              else {
                showWarningNotification("Please use the same ticket to dispose the call ")
              }
            }
          }
          else {
            showWarningNotification("Agent Should be in ACW mode to dispose")
          }
        }
        else {
          showWarningNotification("You have not logged In to AgentToolbar yet")
        }
      }
      else if (event.data.cmd === "login") {
        if (event.data.username === undefined || event.data.username.length < 3 || event.data.username.length > 50) {
          showWarningNotification("User Name is a required , min 3 to max 50 characters allowed.")
        }
        else if (event.data.agentid === undefined || event.data.agentid.length < 2 || event.data.agentid.length > 50) {
          showWarningNotification("Agent ID is a required , min 2 to max 50 characters allowed.")
        }
        else if ((event.data?.sip === false || event.data?.sip === undefined || event.data?.sip === null) &&
          (event.data.phoneNumber === undefined || event.data.phoneNumber.length < 3 || event.data.phoneNumber.length > 17)) {
          showWarningNotification("Phone Number is a required , min 3 to max 17 characters allowed.")
        }
        else if (event.data.pin === undefined || event.data.pin.length < 3 || event.data.pin.length > 50) {
          showWarningNotification("Pin is a required , min 3 to max 50 characters allowed.")
        }
        else {
          let data = {
            customer: event.data.username,
            agentid: event.data.agentid,
            pin: event.data.pin
          }
          data.sip = event.data?.sip ?? false;
          if (data.sip === false) {
            data.phoneNumber = event.data?.phoneNumber;
          }
          handleAgentLogin(data, () => true);
          store.dispatch(setLoginViaAppData(data))
        }
      }
      else if (event.data.cmd === "changeMode") {
        let mode = store.getState().toolbar.agent.mode;
        if (event.data.mode === undefined || event.data.mode === "") {
          showWarningNotification("Give a Mode to Change");
        }
        else {
          if (event.data.mode === "inbound" || event.data.mode === "manual" || event.data.mode === "progressive" || event.data.mode === "preview" || event.data.mode === "chat" || event.data.mode === "blended") {
            if (store.getState().call.isCallEnded) {
              showWarningNotification('Please save the disposition first!');
              return false;
            }
            if (store.getState().call.isComponentOnCall || store.getState().call.isCallAttended || store.getState().call.isCallIncomming || Object.keys(store.getState().digital.answeredChats).length > 0) {
              showWarningNotification('Mode cannot be changed while on call or chat');
              return false;
            }
            if (mode === event.data.mode) {
              showWarningNotification(`You are already in ${mode} mode`);
            }
            else {
              changeAgentMode(event.data.mode)
            }
          }
          else {
            showWarningNotification(`Mode ${event.data.mode} is not available. Only inbound, manual, progressive, preview, chat and blended are available`)
          }
        }
        return;
      }
      else if (event.data.cmd === "changeState") {
        if (store.getState().toolbar.isLoggedIn === true) {
          const agentState = store.getState().toolbar.agent.state;
          if (agentState === AGENT_STATE.NOT_READY) {
            releaseAgent();
          } else if (store.getState().toolbar.agent.state === AGENT_STATE.READY) {
            showWarningNotification("You are already in Ready state")
          }
        } else {
          showWarningNotification("You have not logged In to AgentToolbar yet")
        }
      }
      else if (event.data.cmd === "plugin") {
        if (event.data.name === "freshdesk") {
          store.dispatch(setShowingToolbarInCrm(true))
          let scriptfreshdesk = document.createElement("script");
          scriptfreshdesk.src = app.urls["crm_cdn"] + "freshdesk/freshdesk.js";
          scriptfreshdesk.onload = function () {
            console.log("CA freshdesk integration is installed");
          };
          document.head.appendChild(scriptfreshdesk);
        }
        if (event.data.name === "freshservice") {
          store.dispatch(setShowingToolbarInCrm(true))
          let scriptfreshservice = document.createElement("script");
          scriptfreshservice.src = app.urls["crm_cdn"] + "freshservice/freshservice.js";
          scriptfreshservice.onload = function () {
            console.log("CA freshservice integration is installed");
          };
          document.head.appendChild(scriptfreshservice);
        }
        if (event.data.name === "freshchat") {
          store.dispatch(setShowingToolbarInCrm("freshchat"))
          let scriptfreshservice = document.createElement("script");
          scriptfreshservice.src = app.urls["crm_cdn"] + "freshchat/freshchat.js";
          scriptfreshservice.onload = function () {
            console.log("CA freshchat integration is installed");
          };
          document.head.appendChild(scriptfreshservice);
        }
        if (event.data.name === "zendesk_support") {
          store.dispatch(setShowingToolbarInCrm(true))
          let scriptzendesk = document.createElement("script");
          scriptzendesk.src = app.urls["crm_cdn"] + "zendesk/zendesk.js";
          scriptzendesk.onload = function () {
            console.log("CA zendesk integration is installed");
          };
          document.head.appendChild(scriptzendesk);
        }
        if (event.data.name === "zendesk_sell") {
          store.dispatch(setShowingToolbarInCrm(true))
          let scriptzendesk = document.createElement("script");
          scriptzendesk.src = app.urls["crm_cdn"] + "zendesk/zendesk_sell.js";
          scriptzendesk.onload = function () {
            console.log("CA zendesk sell integration is installed");
          };
          document.head.appendChild(scriptzendesk);
        }
        window.parent.postMessage({ cmd: "sso_login" }, "*");
        return;
      }
      else if (event.data.cmd === "send_whatsapp_message") {
        console.log("CA send whatsapp message", event.data);
        let answeredChats = store.getState().digital.answeredChats;
        let sessionId = Object.values(answeredChats)?.filter((chat) => {
          if (chat?.chatDetails?.channelType?.toLowerCase() === "whatsapp" && chat?.chatDetails?.phoneNumber === event.data.phoneNumber) {
            return chat.chatCustSessionId;
          }
          return null;
        });
        console.log("sessionId", sessionId);
        if (sessionId?.length > 0) {
          store.dispatch(handleActiveSessionId(sessionId[0].chatCustSessionId));
          store.dispatch(handleChatAcceptStatus(true));
        } else {
          localStorage.setItem('crmPhoneNumber', event.data.phoneNumber);
          store.dispatch(addNewTab("Message"));
        }
      }
      else if (event.data.cmd === "sendSms") {
        console.log("message listener : sendSms event received");
        if (event.data.number === undefined || event.data.number === "") {
          showWarningNotification("PhoneNumber is required");
        } else {
          if (store.getState().toolbar.isLoggedIn === true) {
            localStorage.setItem('crmPhoneNumber', event.data.number);
            localStorage.setItem('crmMessageType', 'Sms');
            const savedCampaign = localStorage.getItem('smsSavedCampaign');
            const savedTemplate = localStorage.getItem('smsSavedTemplate');
            if (savedCampaign && savedTemplate) {
              store.dispatch(setSendSmsAutoSend(true));
            } else {
              showWarningNotification("Please select Campaign and Template to send SMS");
            }
            store.dispatch(addNewTab("Message"));
          } else {
            showWarningNotification("You have not logged In to AgentToolbar yet");
          }
        }
      }
      else if (event.data.cmd === "agentInfo") {
        console.log("trigger: agentInfo");
        aToolbar !== undefined && aToolbar.trigger("agentInfo");
        return;
      } else if (event.data.cmd === "auto_login_data" && event.data?.enabled) {
        try {
          if (store.getState().toolbar.isLoggedIn === true) {
            console.log("Agent already logged in, skipping auto-login from CTI settings for freshworks apps.");
            return;
          }
          let { accountName = "", agentId = "", apiKey = "", loginType = "", phoneNumber = "" } = event.data;
          if (!accountName || !agentId || !apiKey || (loginType === 'Phone Number' && !phoneNumber)) {
            console.log("Auto login failed. Please check the call center settings")
            showWarningNotification("Auto login failed. Please check the call center settings");
            return;
          }
          let data = {
            customer: accountName,
            agentid: agentId,
            apiKey: apiKey,
            sip: loginType === 'SIP' ? true : false
          }
          if (!data.sip) {
            data.phoneNumber = phoneNumber;
          }
          let resp = await handleAgentLogin(data, () => true);
          if (resp === "Login success") {
            CookieService.setCookie("agentName", agentId, { expires: 7, samesite: "None", secure: true });
            CookieService.setCookie("sso_data", data, { expires: 7, samesite: "None", secure: true });
          }
        } catch (error) {
          console.error("Error during auto login:", error);
        }
        return;
      } else if (event.data.cmd === "sso_login_data") {
        if (event.data.ca_details.customer === undefined || event.data.ca_details.customer === null || event.data.ca_details.customer === "" || event.data.ca_details.agentId === undefined || event.data.ca_details.agentId === null || event.data.ca_details.agentId === "" || event.data.ca_details.phoneNumber === undefined || event.data.ca_details.phoneNumber === null || event.data.ca_details.phoneNumber === "" || event.data.ca_details.apiKey === undefined || event.data.ca_details.apikey === null || event.data.ca_details.apiKey === "") {
          showWarningNotification("sso login fail . Please configure ca_Account_Id , ca_Agent_Id , ca_PhoneNumber , ca_Api_key  in your App settings")
          return;
        }
        else {
          let data = {
            customer: event.data.ca_details.customer,
            agentid: event.data.ca_details.agentId,
            phoneNumber: event.data.ca_details.phoneNumber,
            apiKey: event.data.ca_details.apiKey
          }
          let resp = await handleAgentLogin(data, () => true);
          if (resp === "Login success") {
            CookieService.setCookie("agentName", event.data.ca_details.agentId, { expires: 7, samesite: "None", secure: true });
            CookieService.setCookie("sso_data", event.data.ca_details, { expires: 7, samesite: "None", secure: true });
          }
          return;
        }
      }
      else if (event.data.cmd === "ticketInfo") {
        if (event.data.data === undefined || event.data.data === "") {
          showWarningNotification("Give Data of the Ticket.")
        }
        else {
          console.log("freshdesk ticket toolbar", event.data);
          aToolbar !== undefined && aToolbar.trigger("ticketInfo", [event.data.data]);
        }
        return;
      }
      else if (event.data.cmd === "storeCrmInfo") {
        if (event.data.crm_info) {
          let { callDetails } = store.getState().call;
          if (callDetails !== null && callDetails !== undefined && typeof callDetails === 'object' && Object.keys(callDetails).length > 0) {
            callDetails = { ...callDetails, crm_info: event.data.crm_info }
            store.dispatch(setCallDetails(callDetails));
          }
        }
        let resp = await getCrmInfo(event)
        console.log(resp);
        return;
      }
      else if (event.data.cmd === "pause") {
        if (store.getState().toolbar.isLoggedIn === true) {
          if (event.data.reason === undefined || event.data.reason === null) {
            showWarningNotification("Reason is required to pause the agent")
            return
          }
          else if (store.getState().call.isCallEnded === true) {
            showWarningNotification("You cannot pause while you are in a ACW State")
            return
          }
          else if (store.getState().toolbar.agent.state === AGENT_STATE.NOT_READY) {
            showWarningNotification("You are already in pause state")
            return
          }
          else {
            const pauseReasonsList = await getPauseReasons()
            let pauseReasonPresented = false;
            let pauseReasonWithTimeLimit = {
              reason: event.data.reason,
              timeLimit: null
            };
            if (pauseReasonsList !== null) {
              pauseReasonsList.map((item) => {
                if (item.reason === pauseReasonWithTimeLimit.reason) {
                  pauseReasonPresented = true
                  pauseReasonWithTimeLimit.reason = item.reason
                  pauseReasonWithTimeLimit.timeLimit = item.timeLimit || 0
                }
              })
            }
            if (pauseReasonPresented) {
              if (store.getState().digital.isChatActive) {
                store.dispatch(pauseAfterSession({ type: true, reason: pauseReasonWithTimeLimit }));
                showSuccessNotification("Agent will be paused after all chats are disposed")
              }
              else {
                pauseAgent(pauseReasonWithTimeLimit)
              }
            }
            else {
              showWarningNotification("reason is not available in pauseReason's List")
            }
          }
        }
        else {
          showWarningNotification("You have not logged In to AgentToolbar yet")
        }
      }
      else if (event.data.cmd === "release") {
        if (store.getState().toolbar.isLoggedIn === true) {
          if (store.getState().call.isCallActivityPresent === true || store.getState().digital.isChatActive) {
            showWarningNotification("You cannot release while you are in a call or chat or ACW state")
          }
          else if (store.getState().toolbar.agent.state === AGENT_STATE.READY) {
            showWarningNotification("You are already in release state")
          }
          else {
            releaseAgent()
          }
        }
        else {
          showWarningNotification("You have not logged In to AgentToolbar yet")
        }
      }
      else if (event.data.cmd === "sso_oauth_callback") {
        const { state, code, error } = event.data;
        if (error) {
          showErrorNotification(error);
          return;
        }
        try {
          let parsed = JSON.parse(state);
          let ssid = parsed?.ssid;
          let provider = parsed?.provider;
          if (!ssid || !provider || !code) {
            console.log("Invalid sso data")
            showErrorNotification("Unable to SSO login");
            return;
          }
          handleAgentLogin({ action: "formLogin", ssid, code, provider }, () => true);
        } catch (e) {
          console.error(e)
          showErrorNotification("Unable to SSO login");
        }
      } else if (event.data.cmd === "sso_token_callback") {
        const { ssid, error } = event.data;
        if (error) {
          showErrorNotification(error);
          return;
        }
        if (ssid) {
          handleAgentLogin({ action: "formLogin", ssid, sso: true }, () => true);
        }
      }

    }
    window?.toolbarMixin?.observable?.trigger(event.data.cmd || "", event.data);
  }
  function notificationListener(event) {
    console.log("Received mobile notification==>", event)
    try {
      if (event.origin === 'Mobile_Platform') {
        if (event.data) {
          WSocketService.handleSocketMessage(event.data)
        } else {
          console.log("Data is missing in event", event)
        }

      }
    } catch (e) {
      console.log("Exception while handling push notifications", e);
    }
  }

  useEffect(() => {
    window.addEventListener("message", messageListener, false);
    window.addEventListener("toolbarListener", messageListener, false);
    window.document.addEventListener("pushNotification", notificationListener, false);
  }, []);

  useEffect(() => {
    let domeainName = window.location.href;
    if (!domeainName.includes("ozonetel") && !domeainName.includes("localhost")) {
      let endpoint = getEndPoint(window.location.href)
      handleHeaderImg(endpoint);
    }

  }, [])

  useEffect(() => {
    if (window.location.href.includes('slashcall')) {
      const link = document.querySelector("link[rel='icon']");
      if (link) {
        link.href = `${process.env.PUBLIC_URL}/slashcall/slashcall-fav.svg`;
      }
      document.title = 'Slashcall';
    }
  }, [])
  async function handleHeaderImg(endpoint) {
    try {
      const urls = await getHeaderImages(endpoint);
      if (urls) {
        urls.map((item) => {
          if (item.includes('fav_')) {
            const link = document.querySelector("link[rel='icon']");
            if (link) {
              link.href = item.slice(0, -1); // Replace 'new-favicon.ico' with the desired favicon image path
            }
          }
        })
      } else {
        console.log("Failed to get URLs.");
      }
    } catch (e) {
      console.log("error while parsing header urls :", e);
    }
  }
  const getEndPoint = (url) => {
    const domain = new URL(url).hostname;
    const domainParts = domain.split(".");
    // const dynamicPart = domainParts.slice(1).join(".");
    if (domainParts.length > 1) {
      return domainParts.slice(1).join(".")
    }
    else if (domainParts.length === 1) {
      return domainParts
      // return domainParts
    } else {
      return null; // or any default value you want to use for URLs with a single path
    }


  }
  const handleVisibilityChange = () => {
    store.dispatch(setToolbarTabActive(true));
  };

  const LoginPage = () => {
    let matches = false
    try {
      matches = window.location.href.includes('dishtv') || false;
    } catch {
      matches = false
    }
    return matches ? <SsoLogin /> : <Login />;
  }


  useEffect(() => {
    document.addEventListener('visibilitychange', handleVisibilityChange, false);
    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, []);
  return (
    <ThemeProvider theme={theme} >
      <BrowserRouter>
        <Routes >
          {/* <Route path="/" element={<Navigate to="/login" />} /> */}
          <Route path={`/login`} element={<LoginPage />} />
          <Route path={`/*`} element={<AgentToolbar />}>
            <Route path={`*`} element={<Toolbar />}></Route>
          </Route>
        </Routes>
      </BrowserRouter>
    </ThemeProvider >
  );

  function AgentToolbar() {
    const searchParams = useLocation().search;
    console.log(("auth user routing searchParams", searchParams))
    if (authUser()) {
      return <Outlet />;
    } else {
      return <Navigate to={`/login${searchParams}`} />;
    }
  }
}

export default App;
